import React, { useState } from 'react';
import {BasicVacancyCard} from "./BasicVacancyCard";
import { RegistrationIsRequired } from '../Modals';
import { Button } from 'antd';
import { Vacancy } from '../../types';

export function VacancyCardNotAuthorized({ vacancy }: {vacancy: Vacancy}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
      setIsModalOpen(true);
  }

  const closeHandler = () => {
      setIsModalOpen(false);
  }

  return (
    <>
      <BasicVacancyCard
        vacancy={vacancy}
      >
        <Button type="primary" onClick={showModal} style={{marginTop: "12px", height: '32px'}}>Откликнуться</Button>
      </BasicVacancyCard>
      <RegistrationIsRequired isOpen={isModalOpen} close={closeHandler}/>
    </>
  )
}